var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { MAX_CONTENT_WIDTH } from '../../constants';
import { classNames } from '../../utils/cn';
var cls = classNames('content-boundary');
export var ContentBoundaryDefaultProps = {
  style: {},
  maxWidth: MAX_CONTENT_WIDTH
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    box-sizing: border-box;\n    width: 100%;\n  "], ["\n    ", "\n    box-sizing: border-box;\n    width: 100%;\n  "])), function (_a) {
    var maxWidth = _a.maxWidth;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), maxWidth);
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var ContentBoundary = React.forwardRef(function (props, ref) {
  var className = props.className,
      children = props.children,
      maxWidth = props.maxWidth,
      id = props.id;

  var style = __assign(__assign({}, props.style), {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  });

  return React.createElement(My.Container, {
    ref: ref,
    id: id,
    style: style,
    className: cls.sub('container')
  }, React.createElement(My.Body, {
    maxWidth: maxWidth,
    className: cls.name(className)
  }, children));
});
ContentBoundary.defaultProps = ContentBoundaryDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;